import { scaleLinear } from '@visx/scale';

export const METRICS = {
  AFFINITY: 'target_audience_affinity',
  REACH: 'target_audience_population_perc',
  BASE: 'base_population_perc',
  PENETRATION: 'penetration',
  RELEVANCY: 'relevancy'
};

export const MAP_CHART_FIELDS_MAX = {
  base_population_perc: 1,
  target_audience_population_perc: 1,
  target_audience_perc: 1
};

export const MAP_CHART_FIELDS_THRESHOLD = {
  target_audience_affinity: 1,
  base_population_perc: 0,
  target_audience_population_perc: 0,
  target_audience_perc: 0,
  relevancy: 0,
  penetration: 0
};

export function debounce(func, wait, immediate) {
  let timeout;
  return () => {
    const context = this;
    const args = arguments;
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

export const isReach = (metric) => {
  return (
    metric === 'target_audience_population_perc' ||
    metric === 'target_audience_perc'
  );
};

export const numberWithCommas = (number) => {
  if (!number) {
    return false;
  }
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const MAP_CHART_FIELDS_LABEL = {
  target_audience_affinity: 'Affinity',
  base_population_perc: 'Base',
  target_audience_population_perc: 'Reach',
  target_audience_perc: 'Reach',
  penetration: 'Penetration',
  relevancy: 'Relevance'
};

export const COLORS = {
  map: ['#007ADD', '#269F49'],
  other: ['#FAB239', '#D6519E', '#007ADD']
};
export const OPAC_COLORS = {
  map: ['#0B5394', '#167A33'],
  other: ['#94920B', '#BA635E', '#0B5394']
};

export const convertHexToHSL = (color, saturation, lightness) => {
  let r = 0;
  let g = 0;
  let b = 0;
  if (color.length === 4) {
    r = '0x' + color[1] + color[1];
    g = '0x' + color[2] + color[2];
    b = '0x' + color[3] + color[3];
  } else if (color.length === 7) {
    r = '0x' + color[1] + color[2];
    g = '0x' + color[3] + color[4];
    b = '0x' + color[5] + color[6];
  }
  // Then to HSL
  r /= 255;
  g /= 255;
  b /= 255;
  const cmin = Math.min(r, g, b);
  const cmax = Math.max(r, g, b);
  const delta = cmax - cmin;
  let h = 0;
  let s = 0;
  let l = 0;

  if (delta === 0) h = 0;
  else if (cmax === r) h = ((g - b) / delta) % 6;
  else if (cmax === g) h = (b - r) / delta + 2;
  else h = (r - g) / delta + 4;

  h = Math.round(h * 60);

  if (h < 0) h += 360;

  l = (cmax + cmin) / 2;
  s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
  s = +(s * saturation).toFixed(1);
  l = +(l * lightness).toFixed(1);

  return 'hsl(' + h + ',' + s + '%,' + l + '%)';
};

export const getColors = (color) => {
  if (!color || color === 'default') {
    return COLORS.other;
  }

  if (color === 'opac') {
    return OPAC_COLORS.other;
  }

  return [
    convertHexToHSL(color, 100, 100),
    convertHexToHSL(color, 100, 50),
    convertHexToHSL(color, 70, 30)
  ];
};

export const getMapColors = (color) => {
  if (!color || color === 'default') {
    return COLORS.map;
  }

  if (color === 'opac') {
    return OPAC_COLORS.map;
  }

  return [
    convertHexToHSL(color, 100, 100),
    convertHexToHSL(color, 100, 50),
    convertHexToHSL(color, 70, 30)
  ];
};

export const getBarColors = (value, threshold, totalCount, color, index) => {
  if (!Array.isArray(color)) {
    if (color && !['default', 'opac'].includes(color)) {
      return convertHexToHSL(color, 100, value < threshold ? 100 : 50);
    }
    const scale = scaleLinear({
      domain: [
        0,
        totalCount === 0 ? 0 : totalCount / 2,
        totalCount === 0 ? 0 : totalCount
      ],
      range: getColors(color)
    });
    return scale(index);
  }
  if (value < threshold) {
    return color[0];
  }
  return color[1];
};
